import React, { useEffect, useState } from 'react';
import { useReframe } from 'nike-re-framejs';
import HeaderArrowIcon from 'nike-ui/src/icons/svg/header-arrow-icon-sv.svg';
import HeaderCrossIcon from 'nike-ui/src/icons/svg/header-cross-icon-sv.svg';
import NikeLogoIcon from '@/icons/NikeLogoIcon';
import { withRouter, useParams } from 'react-router-dom';
import { dispatch } from 'nike-re-framejs';

function ArticleHeader() {
    return (
        <>
            <div className={'page-header-sticker'}>
                <TitleContentWithRouter />
            </div>
            <div className={'page-header-fixer'} />
        </>
    );
}

function TitleContent({ location }) {
    const derefSub = useReframe();
    const [state, setState] = useState(false);
    const fromApp = location?.state?.fromApp;
    const { articleCode } = useParams<{ articleCode: string }>();
    const title = derefSub(['markdown.article.title', articleCode]);

    useEffect(() => {
        setState(fromApp);
    }, [fromApp]);

    function handleClick(e) {
        e.preventDefault();
        dispatch(['history_back']);
    }

    return (
        <nav className={'simple-page-header-content'}>
            <div className="header-btn-go-back" data-atid="main-menu-go-back" onClick={handleClick}>
                {state ? <HeaderArrowIcon /> : <HeaderCrossIcon />}
            </div>
            <div className="simple-page-header-content-title">
                <h1>{title ? title : <NikeLogoIcon width={49} height={27} opacity={1} fill={'#ff8000'} />}</h1>
            </div>
        </nav>
    );
}

export const TitleContentWithRouter = withRouter(TitleContent);

export default ArticleHeader;
